import { IonItem, IonLabel, IonList, useIonModal } from "@ionic/react";
import { useState } from "react";
import useSound from "use-sound";
import useCodes from "../hooks/useCodes";
import openSound from "../sounds/open.wav";
import QRCodeModal from "./QRCodeModal";

export const QRCodeList = ({ pageRef }) => {
  const [selectedCode, setSelectedCode] = useState(undefined);
  const [play] = useSound(openSound);
  const [codes] = useCodes();

  const [present, dismiss] = useIonModal(QRCodeModal, {
    data: selectedCode && selectedCode.lightning_invoice.payreq,
    invoiceId: selectedCode?.id,
    onClose: () => dismiss(),
    subtitle: selectedCode?.description,
    title: `$${selectedCode?.fiat_value}`,
  });

  const handleSelect = (code) => {
    setSelectedCode(code);
    play();
    present({
      presentingElement: pageRef.current,
      swipeToClose: true,
    });
  };

  return (
    <IonList>
      {codes?.map((code, index) => {
        return (
          <IonItem
            key={index}
            detail={true}
            onClick={() => handleSelect(code)}
            button
          >
            <IonLabel className="ion-padding-start">
              <h1>{code?.description}</h1>
              <p>{new Date(code?.created_at * 1000).toLocaleString()}</p>
            </IonLabel>
          </IonItem>
        );
      })}
    </IonList>
  );
};
